import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';
import {Provider} from "react-redux";
import {ConfigProvider} from 'antd';
import store from "./Reducers/store";
import '@ant-design/v5-patch-for-react-19';

const root = ReactDOM.createRoot(document.getElementById('root'));
const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--color-primary').trim();

root.render(
    <React.StrictMode>
        <Provider store={store}>
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: primaryColor,
                    },
                }}
            >
                <App/>
            </ConfigProvider>
        </Provider>
    </React.StrictMode>
);

// reportWebVitals();
